<section class="reviews-master-section" id="opiniones" aria-labelledby="reviews-heading">
  <div class="reviews-container">

    <!-- CABECERA DE SECCIÓN CON EMBLEMA -->
    <div class="reviews-section-header">
      <div class="header-emblem" aria-hidden="true">
        <span class="gold-star">★</span>
        <span class="gold-star main">★</span>
        <span class="gold-star">★</span>
      </div>
      <span class="section-tagline">Experiencias y Notas Sensoriales</span>
      <h2 class="section-title" id="reviews-heading">Calificaciones de Clientes y Catadores</h2>
      <div class="gold-divider" aria-hidden="true">
        <span class="line"></span>
        <span class="diamond">◆</span>
        <span class="line"></span>
      </div>
      <p class="section-subtext">
        Opiniones auténticas de entusiastas y sommeliers sobre {{ productName }}.
      </p>
    </div>

    <!-- TARJETA PRINCIPAL DE RESUMEN DE PUNTUACIÓN (5 ESTRELLAS) -->
    <div class="rating-overview-card">
      <div class="overview-grid">

        <!-- COLUMNA 1: PUNTUACIÓN PROMEDIO -->
        <div class="rating-score-col">
          <div class="score-number">{{ averageRating() | number:'1.1-1' }}</div>
          <div class="stars-row" [attr.aria-label]="averageRating() + ' de 5 estrellas'">
            @for (star of getStarsArray(5); track star) {
            <svg class="star-icon" [class.filled]="star <= averageRating()"
                 [class.half-filled]="star > averageRating() && star - 0.5 <= averageRating()"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path fill-rule="evenodd"
                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                clip-rule="evenodd" />
            </svg>
            }
          </div>
          <div class="reviews-count-badge">
            Basado en <strong>{{ totalReviews() }}</strong> {{ totalReviews() === 1 ? 'opinión' : 'opiniones' }}
          </div>
          <div class="recommendation-pill">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            <span>{{ recommendationPercentage() }}% de aprobación</span>
          </div>
        </div>

        <!-- COLUMNA 2: BARRAS DE DISTRIBUCIÓN DE ESTRELLAS -->
        <div class="rating-distribution-col">
          <div class="distribution-list" role="list">
            @for (item of starDistribution(); track item.star) {
            <button class="dist-row" (click)="filterByStar(item.star)"
                    [class.active]="selectedStarFilter() === item.star"
                    [attr.aria-label]="'Filtrar por ' + item.star + ' estrellas: ' + item.count + ' opiniones'">
              <span class="dist-star-label">{{ item.star }} ★</span>
              <div class="progress-track">
                <div class="progress-bar" [style.width.%]="item.percentage"></div>
              </div>
              <span class="dist-count">{{ item.count }}</span>
            </button>
            }
          </div>
        </div>

        <!-- COLUMNA 3: LLAMADO A LA ACCIÓN / BOTÓN DE OPINIÓN -->
        <div class="rating-cta-col">
          <div class="cta-box">
            <div class="discount-promo-pill">
              <span class="promo-gift-icon">🎁</span>
              <span class="promo-text">10% OFF en tu compra</span>
            </div>
            <h3 class="cta-title">¿Has degustado este destilado?</h3>
            <p class="cta-desc">Comparte tu experiencia sensorial y obtén automáticamente un <strong>10% de descuento</strong> en tu compra.</p>
            <button class="btn-write-review" (click)="toggleForm()" [attr.aria-expanded]="isFormOpen()">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              <span>{{ isFormOpen() ? 'Cerrar Formulario' : 'Escribir Opinión y Obtener 10%' }}</span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- TARJETA DE RECOMPENSA DE DESCUENTO DEL 10% TRAS ENVIAR OPINIÓN -->
    @if (unlockedDiscount()) {
    <div class="discount-reward-card" role="alert">
      <div class="reward-sparkle" aria-hidden="true">✨</div>
      <div class="reward-content">
        <div class="reward-badge-line">
          <span class="reward-tag">🎉 ¡Descuento Exclusivo Desbloqueado!</span>
          <button class="btn-dismiss-reward" (click)="dismissDiscount()" aria-label="Cerrar notificación de descuento">✕</button>
        </div>
        <h3 class="reward-title">¡Gracias por tu cata sensorial!</h3>
        <p class="reward-desc">
          Hemos activado automáticamente un <strong>10% de descuento</strong> en tu carrito de compras para tu pedido de destilados.
        </p>
        <div class="reward-coupon-row">
          <div class="coupon-box" title="Código de Cupón">
            <span class="coupon-label">CUPÓN:</span>
            <span class="coupon-code">{{ unlockedDiscount()?.code }}</span>
          </div>
          <button type="button" class="btn-copy-coupon" (click)="copyDiscountCode()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
            <span>{{ isCopied() ? '¡Copiado!' : 'Copiar Código' }}</span>
          </button>
          <span class="coupon-applied-status">✓ 10% Aplicado al Carrito</span>
        </div>
      </div>
    </div>
    }

    <!-- FORMULARIO DESPLEGABLE: ESCRIBIR OPINIÓN -->
    @if (isFormOpen()) {
    <div class="review-form-panel" role="region" aria-label="Formulario de Calificación">
      <div class="panel-inner">

        <!-- BANNER DE INCENTIVO: 10% DE DESCUENTO -->
        <div class="form-discount-banner">
          <div class="banner-icon-col">
            <span class="gift-icon">🎁</span>
          </div>
          <div class="banner-text-col">
            <h4 class="banner-heading">¡10% de Descuento en tu Compra!</h4>
            <p class="banner-subtext">
              Completa tu calificación y opinión honesta sobre este destilado para recibir de inmediato un <strong>cupón del 10% OFF</strong> aplicado a tu compra.
            </p>
          </div>
          <div class="banner-badge-col">
            <span class="banner-pill">-10% OFF</span>
          </div>
        </div>

        <div class="form-header">
          <h3 class="form-title">Comparte tu Calificación y Reseña</h3>
          <p class="form-subtitle">Valora las notas aromáticas, el cuerpo y el final de este espirituoso.</p>
        </div>

        <form [formGroup]="reviewForm" (ngSubmit)="submitReview()" class="form-grid">

          <!-- SELECTOR INTERACTIVO DE 5 ESTRELLAS -->
          <div class="form-group full-width rating-picker-group">
            <label class="form-label">Tu Calificación General *</label>
            <div class="interactive-stars-picker" (mouseleave)="clearHoverRating()" role="radiogroup" aria-label="Puntuación de 1 a 5 estrellas">
              @for (star of getStarsArray(5); track star) {
              <button type="button" class="star-btn"
                      [class.active]="star <= (hoverRating() || reviewForm.get('rating')?.value || 5)"
                      (mouseenter)="setHoverRating(star)"
                      (click)="setRating(star)"
                      [attr.aria-label]="star + ' estrellas'">
                <svg class="picker-star-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                    clip-rule="evenodd" />
                </svg>
              </button>
              }
            </div>
            <span class="rating-text-feedback">
              {{ getStarRatingText(hoverRating() || reviewForm.get('rating')?.value || 5) }}
            </span>
          </div>

          <!-- NOMBRE DEL CLIENTE -->
          <div class="form-group half-width">
            <label for="review-author" class="form-label">Tu Nombre o Alias *</label>
            <input id="review-author" type="text" formControlName="customer_name" class="form-input"
                   placeholder="Ej. Juan Pérez o Catador Andino" />
            @if (reviewForm.get('customer_name')?.invalid && reviewForm.get('customer_name')?.touched) {
            <span class="error-msg">Por favor ingresa tu nombre (mínimo 2 caracteres).</span>
            }
          </div>

          <!-- CIUDAD / UBICACIÓN -->
          <div class="form-group half-width">
            <label for="review-city" class="form-label">Ciudad / Ubicación (Opcional)</label>
            <input id="review-city" type="text" formControlName="customer_city" class="form-input"
                   placeholder="Ej. Quito, Ecuador" />
          </div>

          <!-- TÍTULO DE LA OPINIÓN -->
          <div class="form-group full-width">
            <label for="review-title" class="form-label">Título de tu Reseña *</label>
            <input id="review-title" type="text" formControlName="title" class="form-input"
                   placeholder="Ej. Extraordinario balance y sedosidad en copa" />
            @if (reviewForm.get('title')?.invalid && reviewForm.get('title')?.touched) {
            <span class="error-msg">Ingresa un título breve para tu opinión.</span>
            }
          </div>

          <!-- COMENTARIO DETALLADO -->
          <div class="form-group full-width">
            <label for="review-comment" class="form-label">Tu Opinión Sensorial / Reseña *</label>
            <textarea id="review-comment" rows="4" formControlName="comment" class="form-textarea"
                      placeholder="Describe qué te parecieron el aroma (nariz), la entrada en boca (paladar), la persistencia del final o el maridaje..."></textarea>
            @if (reviewForm.get('comment')?.invalid && reviewForm.get('comment')?.touched) {
            <span class="error-msg">Por favor comparte una descripción de al menos 10 caracteres.</span>
            }
          </div>

          <!-- BOTONES DE ACCIÓN DEL FORMULARIO -->
          <div class="form-actions full-width">
            <button type="button" class="btn-cancel" (click)="toggleForm()" [disabled]="isSubmitting()">
              Cancelar
            </button>
            <button type="submit" class="btn-submit-review" [disabled]="isSubmitting()">
              @if (isSubmitting()) {
              <div class="spinner-small" aria-hidden="true"></div>
              <span>Publicando opinión...</span>
              } @else {
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              <span>Publicar Calificación</span>
              }
            </button>
          </div>

        </form>
      </div>
    </div>
    }

    <!-- BARRA DE FILTROS Y ORDENAMIENTO -->
    <div class="reviews-filter-bar">
      <div class="filter-left">
        @if (selectedStarFilter() !== null) {
        <div class="active-filter-chip">
          <span>Mostrando {{ selectedStarFilter() }} ★</span>
          <button class="btn-clear-filter" (click)="filterByStar(null)" aria-label="Limpiar filtro de estrellas">✕</button>
        </div>
        } @else {
        <span class="filter-status">Mostrando todas las {{ totalReviews() }} opiniones</span>
        }
      </div>

      <div class="filter-right">
        <label for="sort-select" class="sort-label">Ordenar por:</label>
        <div class="sort-buttons" role="group" aria-label="Ordenar opiniones">
          <button class="sort-pill" [class.active]="selectedSort() === 'recent'" (click)="setSort('recent')">
            Más recientes
          </button>
          <button class="sort-pill" [class.active]="selectedSort() === 'highest'" (click)="setSort('highest')">
            Mayor puntuación
          </button>
          <button class="sort-pill" [class.active]="selectedSort() === 'helpful'" (click)="setSort('helpful')">
            Más útiles
          </button>
        </div>
      </div>
    </div>

    <!-- LISTADO DE OPINIONES DE CLIENTES -->
    @if (isLoading()) {
    <div class="reviews-loader" role="status" aria-live="polite">
      <div class="spinner" aria-hidden="true"></div>
      <span>Cargando opiniones de catadores...</span>
    </div>
    } @else if (filteredReviews().length === 0) {
    <div class="no-reviews-box">
      <p>No se encontraron opiniones con el filtro seleccionado.</p>
      <button class="btn-reset-filter" (click)="filterByStar(null)">Ver todas las opiniones</button>
    </div>
    } @else {
    <div class="reviews-grid">
      @for (review of filteredReviews(); track review.id) {
      <article class="review-card" itemprop="review" itemscope itemtype="https://schema.org/Review">
        
        <!-- CABECERA DE LA TARJETA: AVATAR, AUTOR, VERIFICACIÓN Y FECHA -->
        <div class="card-author-row">
          <div class="author-avatar" aria-hidden="true">
            {{ getInitials(review.customer_name) }}
          </div>
          <div class="author-meta">
            <div class="name-badge-line">
              <span class="author-name" itemprop="author" itemscope itemtype="https://schema.org/Person">
                <span itemprop="name">{{ review.customer_name }}</span>
              </span>
              @if (review.is_verified) {
              <span class="verified-badge" title="Comprador / Catador Verificado">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd" />
                </svg>
                <span>Verificado</span>
              </span>
              }
            </div>
            <div class="author-sub">
              @if (review.customer_city) {
              <span class="author-city">{{ review.customer_city }}</span>
              <span class="bullet" aria-hidden="true">·</span>
              }
              <time class="review-date" itemprop="datePublished" [attr.datetime]="review.created_at">
                {{ formatDate(review.created_at) }}
              </time>
            </div>
          </div>
        </div>

        <!-- ESTRELLAS INDIVIDUALES DE LA RESEÑA -->
        <div class="card-stars-row" itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">
          <meta itemprop="ratingValue" [content]="review.rating" />
          <meta itemprop="bestRating" content="5" />
          <meta itemprop="worstRating" content="1" />
          @for (star of getStarsArray(5); track star) {
          <svg class="star-icon-small" [class.filled]="star <= review.rating"
               xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd"
              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
              clip-rule="evenodd" />
          </svg>
          }
          <span class="rating-number-tag">{{ review.rating }}.0</span>
        </div>

        <!-- TÍTULO Y COMENTARIO -->
        @if (review.title) {
        <h3 class="review-title-text" itemprop="name">{{ review.title }}</h3>
        }
        <p class="review-body-text" itemprop="reviewBody">{{ review.comment }}</p>

        <!-- PIE DE TARJETA: BOTÓN DE UTILIDAD -->
        <div class="card-footer-row">
          <button class="btn-helpful" (click)="voteHelpful(review)"
                  [class.voted]="votedReviewIds().has(review.id)"
                  [disabled]="votedReviewIds().has(review.id)"
                  [attr.aria-label]="'Marcar esta opinión como útil. Votos actuales: ' + (review.helpful_count || 0)">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
            </svg>
            <span>Útil @if ((review.helpful_count || 0) > 0) { ({{ review.helpful_count }}) }</span>
          </button>
        </div>

      </article>
      }
    </div>
    }

  </div>
</section>

<!-- NOTIFICACIÓN TOAST -->
@if (successToast()) {
<div class="review-toast-notification" role="status" aria-live="polite">
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24"
    stroke="currentColor" stroke-width="2" class="toast-check-icon">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
  <span class="toast-text">{{ successToast() }}</span>
</div>
}
